import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Card, CardContent, CardHeader, CircularProgress, Hidden, useMediaQuery, useTheme } from '@material-ui/core';
import { getVisitasPorMes } from '../../../../../services/DashboardService';
import Chart from 'react-apexcharts';
import { IOSSwitch } from '../../../../../components/';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import IconButton from '@material-ui/core/IconButton';
import FormatListBulletedIcon from '@material-ui/icons/FormatListBulleted';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import ToggleButton from '@material-ui/lab/ToggleButton';
import DateRangeIcon from '@material-ui/icons/DateRange';
import moment from 'moment';


const useStyles = makeStyles(() => ({
  root: {
    borderRadius: 20,
  },
  chartContainer: {
    height: 400,
    position: 'relative'
  },
  actions: {
    justifyContent: 'flex-end'
  }
}));

const GraficoVisitasPorMes = props => {
  const PERIODO_ANUAL = 0;
  const PERIODO_MENSAL = 1;
  const PERIODO_SEMANAL = 2;
  const PERIODO_PERSONALIZADO = 3;
  const { className, ...rest } = props;
  const theme = useTheme();
  const [dadosVisitasPorMes, setDadosVisitasPorMes] = useState({
    retornoPeriodo: [],
    meta: 0,
    valorTotalVisitasAnoAtual: {
      ano: '',
      valor: 0
    },
    valorTotalVisitasAnoAnterior: {
      ano: '',
      valor: 0
    }

  });
  const [mostrarProgress, setMostrarProgress] = useState(true);
  const [mostrarAlertaErro, setMostrarAlertaErro] = useState(false);
  const [meses, setMeses] = useState([]);
  const [valores, setValores] = useState([]);
  const [mostrarAnaliseDetalhada, setMostrarAnaliseDetalhada] = useState(false);
  let [periodo, setPeriodo] = useState(PERIODO_ANUAL);
  let [dataInicialPersonalizada, setDataInicialPersonalizada] = useState(null);
  let [dataFinalPersonalizada, setDataFinalPersonalizada] = useState(null);
  const [refreshState, setRefreshState] = useState(new Date());
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'), {
    defaultMatches: true
  });
  const classes = useStyles();

  useEffect(() => {
    try {
      getDados();
    }
    catch (e) {

    }
  }, []);

  async function getDados() {
    try {
      setMostrarProgress(true);
      let dados = await getVisitasPorMes(periodo, dataInicialPersonalizada, dataFinalPersonalizada);
      if (dados.isSuccess) {
        setMostrarProgress(false);
        setDadosVisitasPorMes(dados.result);
        let mesesNovo = [];
        let valoresNovo = [];
        dados.result.retornoPeriodo.map(mes => {
          mesesNovo.push(mes.nomePeriodo);
          valoresNovo.push(mes.valorTotal);
        });
        setMeses(mesesNovo);
        setValores(valoresNovo);

      } else {
        setMostrarProgress(false);
        setMostrarAlertaErro(true);
      }
    } catch (e) {
      setMostrarProgress(false);
      setMostrarAlertaErro(true);
    }
  }

  const aoModificarPeriodo = async (event, novoPeriodo) => {
    periodo = novoPeriodo;
    setPeriodo(novoPeriodo);
    if (novoPeriodo === PERIODO_PERSONALIZADO) {
      setValores([]);
      setMeses([]);
    }
    await getDados();
  };

  const aoModificarDataInicialPersonalizada = async date => {
    dataInicialPersonalizada = date;
    setDataInicialPersonalizada(date);
    if (dataInicialPersonalizada && dataFinalPersonalizada && moment.isDate(dataInicialPersonalizada) && moment.isDate(dataFinalPersonalizada)) {
      await getDados();
    }
  };

  const aoModificarDataFinalPersonalizada = async date => {
    dataFinalPersonalizada = date;
    setDataFinalPersonalizada(date);
    if (dataInicialPersonalizada && dataFinalPersonalizada && moment.isDate(dataInicialPersonalizada) && moment.isDate(dataFinalPersonalizada)) {
      await getDados();
    }
  };

  async function alternarParaPeriodosDeterminados(event) {
    event.preventDefault();
    periodo = PERIODO_ANUAL;
    setPeriodo(PERIODO_ANUAL);
    setDataInicialPersonalizada(null);
    setDataFinalPersonalizada(null);
    setRefreshState(new Date());
    await getDados();
  }

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
      elevation={3}
    >
      <CardHeader
        action={
          <FormControlLabel
            labelPlacement="start"
            label="Mostrar análise detalhada"
            control={<IOSSwitch checked={mostrarAnaliseDetalhada} onClick={e => {setMostrarAnaliseDetalhada(!mostrarAnaliseDetalhada)}}/>}
          />

        }
        title="Análise de visitas anual"
      />
      <CardContent>
        {
          !mostrarProgress &&
          <Grid
            container
          >
            {
              isDesktop &&
              <Grid
                item
                md={6}
              >
              </Grid>
            }
            <Grid
              item
              md={6}
              xs={12}
              style={{
                display: 'flex',
                justifyContent: 'flex-end'
              }}
            >
              {periodo === PERIODO_PERSONALIZADO ?
                <Grid
                  container
                  spacing={2}
                >
                  <Grid
                    item
                    md={5}
                    xs={5}
                  >
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <Grid container justify="space-around">
                        <KeyboardDatePicker
                          fullWidth
                          margin="dense"
                          inputVariant="outlined"
                          orientation="landscape"
                          id="dataInicialPersonalizada"
                          label="Data inicial"
                          format="dd/MM/yyyy"
                          size='small'
                          value={dataInicialPersonalizada}
                          onChange={aoModificarDataInicialPersonalizada}
                          KeyboardButtonProps={{
                            'aria-label': 'change date',
                          }}
                          InputAdornmentProps={{ position: "end" }}
                        />
                      </Grid>
                    </MuiPickersUtilsProvider>
                  </Grid>
                  <Grid
                    item
                    md={5}
                    xs={5}
                  >
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <Grid container justify="space-around">
                        <KeyboardDatePicker
                          fullWidth
                          margin="dense"
                          inputVariant="outlined"
                          orientation="landscape"
                          id="dataFinalPersonalizada"
                          label="Data final"
                          format="dd/MM/yyyy"
                          size='small'
                          value={dataFinalPersonalizada}
                          onChange={aoModificarDataFinalPersonalizada}
                          KeyboardButtonProps={{
                            'aria-label': 'change date',
                          }}
                          InputAdornmentProps={{ position: "end" }}
                        />
                      </Grid>
                    </MuiPickersUtilsProvider>
                  </Grid>
                  <Grid
                    item
                    md={1}
                    xs={1}
                  >
                    <IconButton
                      aria-label="delete"
                      className={classes.margin}
                      size="medium"
                      onClick={ e => alternarParaPeriodosDeterminados(e) }
                    >
                      <FormatListBulletedIcon fontSize="inherit" />
                    </IconButton>
                  </Grid>
                </Grid>
                :
                <ToggleButtonGroup
                  value={periodo}
                  exclusive
                  onChange={aoModificarPeriodo}
                  aria-label="text alignment"
                  size={'small'}
                >
                  <ToggleButton
                    value={PERIODO_SEMANAL}
                    aria-label="right aligned"
                    style={{
                      borderTopLeftRadius: 25,
                      borderBottomLeftRadius: 25,
                    }}
                  >
                    SEMANAL
                  </ToggleButton>
                  <ToggleButton
                    value="center"
                    aria-label="centered"
                    value={PERIODO_MENSAL}
                  >
                    MENSAL
                  </ToggleButton>
                  <ToggleButton
                    value={PERIODO_ANUAL}
                    aria-label="left aligned"
                  >
                    ANUAL
                  </ToggleButton>
                  <ToggleButton
                    value={PERIODO_PERSONALIZADO}
                    style={{
                      borderTopRightRadius: 25,
                      borderBottomRightRadius: 25,
                    }}
                  >
                    <DateRangeIcon
                      style={{
                        marginLeft: 5,
                        marginRight: 5
                      }}
                    />
                  </ToggleButton>
                </ToggleButtonGroup>
              }
            </Grid>
          </Grid>
        }
        <Grid
          container
        >
          {
            mostrarProgress &&
            <Grid
              container
              style={{
                display: 'flex',
                justifyContent: 'center'
              }}
            >
              <Grid
                item
                md={12}
                xs={12}
                style={{
                  height: 400,
                  display: 'flex',
                  justifyContent: 'center'
                }}
              >
                <CircularProgress
                />
              </Grid>
            </Grid>
          }
          {
            mostrarAnaliseDetalhada && !mostrarProgress &&
            <Hidden xsDown>
              <Grid
                item
                md={4}
                xs={12}
              >
                <Grid
                  container
                  spacing={3}
                >
                  <Grid
                    item
                    md={12}
                    xs={12}
                  >
                    <Chart
                      options={{
                        chart: {
                          height: 350,
                          type: 'radialBar',
                        },
                        plotOptions: {
                          radialBar: {
                            hollow: {
                              size: '60%',
                            }
                          },
                        },
                        colors: [theme.palette.primary.main],
                        labels: ['Meta anual'],
                      }}
                      type={'radialBar'}
                      series={[(dadosVisitasPorMes.meta ? dadosVisitasPorMes.meta : 0).toFixed(2)]}
                      height={250}
                    />
                  </Grid>
                  <Grid
                    item
                    md={12}
                    xs={12}
                  >
                    <Grid
                      container
                    >
                      <Grid
                        item
                        md={12}
                        xs={12}
                      >
                        <List className={classes.root}>
                          <ListItem  role={undefined} dense button>
                            <ListItemText id={1} primary={`VALOR RECEBIDO EM ${dadosVisitasPorMes.valorTotalVisitasAnoAnterior.ano} :`} />
                            <ListItemSecondaryAction>
                              <ListItemText id={2} primary={`${dadosVisitasPorMes.valorTotalVisitasAnoAnterior.valor.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}`} />
                            </ListItemSecondaryAction>
                          </ListItem>
                          <ListItem  role={undefined} dense button>
                            <ListItemText id={3} primary={`VALOR RECEBIDO EM ${dadosVisitasPorMes.valorTotalVisitasAnoAtual.ano} :`} />
                            <ListItemSecondaryAction>
                              <ListItemText id={4} primary={`${dadosVisitasPorMes.valorTotalVisitasAnoAtual.valor.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}`} />
                            </ListItemSecondaryAction>
                          </ListItem>
                        </List>
                      </Grid>
                    </Grid>
                  </Grid>

                </Grid>
              </Grid>
            </Hidden>
          }
          {
            !mostrarProgress &&
            <Grid
              item
              md={mostrarAnaliseDetalhada ? 8 : 12}
              xs={12}
            >
              <div className={classes.chartContainer}>
                <Chart
                  options={ {
                    chart: {
                      height: 350,
                      type: 'area',
                      fontFamily: 'Helvetica',
                      toolbar: {
                        show: false
                      }
                    },
                    dataLabels: {
                      enabled: false,
                      style: {
                        colors: [theme.palette.primary.main]
                      }
                    },
                    stroke: {
                      curve: 'smooth'
                    },
                    toolbar: {
                      show: false
                    },
                    xaxis: {
                      type: 'category',
                      categories: meses
                    },
                    yaxis: {
                      title: {
                        text: 'Valor (R$)'
                      },
                      labels: {
                        formatter: function (val) {
                          return val.toFixed(2);
                        },
                      },
                    },
                    tooltip: {
                      x: {
                        format: 'dd/MM/yy HH:mm'
                      },
                    },
                    colors: [theme.palette.primary.main],

                    fill: {
                      colors: [theme.palette.primary.main]
                    },
                    grid: {
                      show: true,
                      strokeDashArray: 0,
                      position: 'back',
                      xaxis: {
                        lines: {
                          show: false
                        }
                      },
                      yaxis: {
                        lines: {
                          show: true
                        }
                      },
                      row: {
                        colors: undefined,
                        opacity: 0.5
                      },
                      column: {
                        colors: undefined,
                        opacity: 0.5
                      },
                      padding: {
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0
                      },
                      stroke: {
                        lineCap: 'round'
                      },
                    },
                  }}
                  series={[
                    {
                      name: 'Visitas no mês',
                      data: valores
                    },
                  ]} type="area" height={400} />
                {/*<Bar*/}
                {/*    data={data}*/}
                {/*    options={options}*/}
                {/*  />*/}
              </div>
            </Grid>
          }
        </Grid>
      </CardContent>
    </Card>
  );
};

GraficoVisitasPorMes.propTypes = {
  className: PropTypes.string
};

export default GraficoVisitasPorMes;
